<template>
  <div id="content">
    <div id="product">
      <div class="nav_1">
        <div v-for="cl in classs" :key="cl.id">
          <a
            @click="changeclass(cl.id)"
            v-if="$route.params.id == cl.id"
            :href="'/#/product/' + cl.id"
            class="on"
          >
            <span v-if="$i18n.locale == 'en'">{{ cl.name_en }}</span>
            <span v-else>{{ cl.name }}</span>
          </a>
          <a v-else :href="'/#/product/' + cl.id" @click="changeclass(cl.id)">
            <span v-if="$i18n.locale == 'en'">{{ cl.name_en }}</span>
            <span v-else>{{ cl.name }}</span>
          </a>
        </div>
        <!-- <a href="list.php?pid=2&amp;ty=13" class="on">遥控车系列</a> -->
        <div class="clear"></div>
      </div>
      <div class="product">
        <ul>
          <li v-for="p in products" :key="p.id">
            <a :href="'/#/productdetail/'+p.id" target="_blank"
              ><img :src="p.image" alt=""
            /></a>
            <span class="le" v-if="$i18n.locale=='en'">{{p.name_en}}</span>
            <span class="le" v-else >{{p.name}}</span>
            <em><a v-if="$i18n.locale=='en'" :href="'/productdetail/'+p.id">+MORE</a>
            <a v-else :href="'/#/productdetail/'+p.id">+了解更多</a></em>
          </li>
        </ul>
      </div>
      <!-- <div class="page">
        <a href="javascript:void()">首页</a>
        <a href="javascript:void()">&lt;</a>
        <a href="javascript:void()" class="on">1</a>
        <a href="?pid=2&amp;ty=13&amp;page=2">2</a>
        <a href="?pid=2&amp;ty=13&amp;page=3">3</a>
        <a href="?pid=2&amp;ty=13&amp;page=2">&gt;</a>
        <a href="?pid=2&amp;ty=13&amp;page=3">末页</a>
      </div> -->
    </div>
  </div>
</template>

<script>
import fetch from "@/utils/axios";
export default {
  components: {},
  name: "Product",
  data() {
    return {
      classs: [],
      products: [],
      page_index: 1,
      big_class:0,
      keyword:0,
    };
  },
  created(){
    this.big_class=this.$route.params.id

    this.keyword=this.$route.params.key
  },
  mounted() {
    // 使用
    const params = { type: 1 }; // 参数
    fetch.post("/api/ApiProClass/GetAppHomeClass", params).then(
      (res) => {
        this.classs = res;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
    const productparam = {page_index: this.page_index,key:this.keyword }; // 参数
    if(this.big_class!=0)
    {
      productparam.big_class=this.big_class;
    }
    fetch.post("/api/ApiProduct/GetProductList", productparam).then(
      (res) => {
        this.products = res;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
  },
  methods: {
    changeclass(cl) {
      this.big_class=cl;
      this.page_index = 1;
      const productparam = {big_class:this.big_class, page_index: this.page_index }; // 参数
      fetch.post("/api/ApiProduct/GetProductList", productparam).then(
        (res) => {
          this.products = res;
        },
        (error) => {
          alert(JSON.stringify(error));
        }
      );
    },
  },
  scrollToBottom: function () {
    alert('scrollToBottom')
}
};
</script>

<style>
#product {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 120px;
}

.nav_1 {
  width: 1400px;
  margin: 5px auto auto;
}
.nav_1 a {
  display: block;
  float: left;
  font-size: 14px;
  color: #333;
  width: 180px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  background: #e6e6e6;
  border-bottom: 3px #dbdbdb solid;
  margin-right: 10px;
}
.nav_1 a:hover {
  background: #00a0e9;
  color: #fff;
  border-bottom: 3px #028fcf solid;
}
.nav_1 a.on {
  background: #00a0e9;
  color: #fff;
  border-bottom: 3px #028fcf solid;
}

.product {
  width: 1400px;
  overflow: hidden;
  margin: 5px auto auto;
}
.product ul {
  width: 1417px;
}
.product li {
  float: left;
  width: 242px;
  display: inline-block;
  padding: 9px;
  background: #f5f5f5;
  margin-top: 25px;
  margin-right: 17px;
}
.product li img {
  display: block;
  border: 0;
  width: 242px;
  height: 161px;
  overflow: hidden;
}
.product li span {
  display: block;
  text-align: left;
  width: 100%;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  color: #333;
  overflow: hidden;
  margin-top: 4px;
}
.product li em {
  display: block;
  text-align: right;
  font-style: normal;
  font-size: 12px;
  line-height: 24px;
}
.product li em a {
  color: #999;
}
.product li:hover {
  background: #00a0e9;
}
.product li:hover span {
  color: #fff;
}
.product li:hover em a {
  color: #fff;
}

.page {
  width: 1100px;
  margin: 40px auto;
  text-align: center;
  font-size: 12px;
  color: #333;
}
.page a {
  color: #333;
  padding: 7px 12px;
  border: 1px #ccc solid;
  margin: 0px 2px;
}
.page a:hover {
  border: 1px #01a4e9 solid;
  background: #01a4e9;
  color: #fff;
}
.page span {
  padding: 7px 12px;
  background: #01a4e9;
  color: #fff;
  border: 1px #01a4e9 solid;
  margin: 0px 2px;
}
</style>



// WEBPACK FOOTER //
// src/Product.vue